import { Provider } from '@angular/core';
import { AuthorizationGuard } from './authorization-azure.guard';
import { ScopeGuard } from './permission.guard';

export const guardProviders: Provider[] = [AuthorizationGuard];
